<template>
  <div></div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import SurveyUtils from '@/utils/survey'
import { PUBLIC_ROUTES, SURVEY_ROUTES_NAME } from '@/constant/routes'

export default {
  data() {
    return {
      observer: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters(['isEURegion']),
    isPublicRouteName() { // for more readable code than isInvalidTokenModalVisible
      const routeName = this.$route && this.$route.name
      return PUBLIC_ROUTES.includes(routeName)
    },
  },
  watch: {
    $route: async function checkRouteChange(to) {
      if (this.isPublicRouteName || this.isEURegion) return
      if (!SurveyUtils.alreadyHasSurveyScript()) {
        await SurveyUtils.initActiveSurveyData()
      }
      SurveyUtils.checkToShowSurveyOnAPage(to.path)
    },
  },
  async created() {
    if (this.isPublicRouteName || this.isEURegion) return

    this.observer = new MutationObserver(() => {
      const ce = document.querySelector('crazyegg-survey')
      if (ce?.shadowRoot) {
        this.observer.disconnect()
        this.observer = null
        setTimeout(() => {
          this.centerCrazyEggSurvey(ce)
        }, 300)
      }
    })

    if (SURVEY_ROUTES_NAME.includes(this.$route.name)) {
      this.observer.observe(document, {
        childList: true,
        subtree: true,
      })
    }

    await SurveyUtils.initActiveSurveyData()
    SurveyUtils.checkToShowSurveyOnAPage(this.$route.path)
    window.getSurveyAndCheckVisibilityBySurveyCode = SurveyUtils.getSurveyAndCheckVisibilityBySurveyCode
  },
  beforeDestroy() {
    // Clean up to avoid memory leaks
    delete window.getSurveyAndCheckVisibilityBySurveyCode

    // Disconnect observer
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  },
  methods: {
    centerCrazyEggSurvey(ce) {
      const popup = ce.shadowRoot.querySelector('#main div')
      const dropDown = ce.shadowRoot.querySelector('#main div div button')
      if (dropDown) dropDown.style.display = 'none'
      const popupWidth = popup.offsetWidth
      const popupHeight = popup.offsetHeight
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      Object.assign(popup.style, {
        left: `${(windowWidth - popupWidth) / 2}px`,
        bottom: `${(windowHeight - popupHeight) / 2}px`,
      })
    },
  },
}
</script>
